import { render, staticRenderFns } from "./task_step3.vue?vue&type=template&id=2dfbe8ce&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./task_step3.vue?vue&type=script&lang=js"
export * from "./task_step3.vue?vue&type=script&lang=js"
import style0 from "./task_step3.vue?vue&type=style&index=0&id=2dfbe8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbe8ce",
  null
  
)

export default component.exports